import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Spin } from 'antd';

import { api } from '@/lib/api';
import { type AuthUser, useAuthStore } from '@/stores/authStore';

/** Protected route guard：idle 时 /auth/me bootstrap;未认证→/login;must_change→/account/change-password。 */
export default function RequireAuth() {
  const user = useAuthStore((s) => s.user);
  const status = useAuthStore((s) => s.status);
  const setUser = useAuthStore((s) => s.setUser);
  const setStatus = useAuthStore((s) => s.setStatus);
  const location = useLocation();

  useEffect(() => {
    if (status === 'idle') {
      setStatus('loading');
      api
        .get<AuthUser>('/auth/me')
        .then(({ data }) => setUser(data))
        .catch(() => setStatus('unauthenticated'));
    }
  }, [status, setUser, setStatus]);

  if (status === 'idle' || status === 'loading') {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  if (status !== 'authenticated' || !user) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  if (user.must_change_password && location.pathname !== '/account/change-password') {
    return <Navigate to="/account/change-password" replace />;
  }

  return <Outlet />;
}
